import { TimePanelConfig } from '../schema/TimePanelConfig';
import { HeaderHeight } from 'owa-flex-pane/lib/components/FlexPaneVariables';

// initialize with default values for OWA modules
let timePanelConfig: TimePanelConfig = {
    abovePanelHeight: HeaderHeight,
    initialPanelView: 'Calendar',
    initialCalendarView: 'Agenda',
    areFREsDisabled: false,
    isFullComposeEnabled: false,
    isClosePaneButtonEnabled: false,
    isTasksViewDisabled: false,
    isModuleDeeplinkDisabled: false,
};

export function initializeTimePanelConfig(customConfig: TimePanelConfig) {
    timePanelConfig = { ...customConfig };
}

export function getTimePanelConfig(): TimePanelConfig {
    return timePanelConfig;
}
